import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/integrations")({
  component: () => (
    <Breadcrumb label="Integrations" to="/integrations">
      <Outlet />
    </Breadcrumb>
  ),
});
